import React from "react";
import * as S from "./myDrivePageContent.style";
import { ReactComponent as IconArrow } from "../../../styles/assets/svg/icon-arrow-detail.svg";
import { ReactComponent as IconRouteArrow } from "../../../styles/assets/svg/icon-route-arrow.svg";
import { DataItemBox } from "../../atoms/DataItemBox";
import { OrderType, Transportation } from "../../../interface/transportation";
import dayjs from "dayjs";
import { formatPrice } from "../../../common/common.fn";
import { translateOrderState } from "../../../lib/orderStateTranslator";

type MyDrivePageContentType = {
  myCompletedTransportationData: Array<OrderType>;
  onDetailPageMoveHandler: (data: OrderType) => void;
};

const MyDrivePageContent = ({
  myCompletedTransportationData,
  onDetailPageMoveHandler,
}: MyDrivePageContentType) => {
  console.log("myCompletedTransportationData", myCompletedTransportationData);
  return (
    <S.MyDrivePageContentLayout>
      {myCompletedTransportationData?.length !== 0 &&
        myCompletedTransportationData?.map((item: OrderType, idx) => {
          return (
            <S.MainContentsList>
              <S.MainContentsItem>
                <S.DataItemBox>
                  <S.DataHeadBox>
                    <div style={{ whiteSpace: "nowrap" }}>
                      <span>운송번호</span>
                      {item?.order_number}
                    </div>
                  </S.DataHeadBox>

                  <S.DataRouteBox>
                    <DataItemBox
                      fontWeight="bold"
                      fontSize="1.4rem"
                      label="출발지"
                      content={item?.load_place_name}
                      route={true}
                    />
                    <IconRouteArrow />
                    <DataItemBox
                      fontWeight="bold"
                      fontSize="1.4rem"
                      label="작업지"
                      content={item?.work_place_name}
                      route={true}
                    />
                    <IconRouteArrow />
                    <DataItemBox
                      fontWeight="bold"
                      fontSize="1.4rem"
                      label="하차지"
                      content={item?.unload_place_name}
                      route={true}
                    />
                  </S.DataRouteBox>

                  <S.DataListBox>
                    <S.DataListItemBox>
                      {/* 이페이지에서 운송일자라고 하면 운송 완료일자를 말하는 것인가? */}
                      <S.DataListItemText> 운송일자 </S.DataListItemText>
                      <S.DataListItemText className="fontBlack">
                        {dayjs(item?.work_start_time).format("YYYY-MM-DD")}
                      </S.DataListItemText>
                    </S.DataListItemBox>
                    <S.DataListItemBox>
                      <S.DataListItemText> 정산금액 </S.DataListItemText>
                      <S.DataListItemText className="fontBlack">
                        {formatPrice(item?.final_settlement_amount)}원
                      </S.DataListItemText>
                    </S.DataListItemBox>
                  </S.DataListBox>
                </S.DataItemBox>

                <S.DetailRouteBox>
                  <S.StatusToken color={item?.order_state}>
                    <span>{translateOrderState(item?.order_state || "")}</span>
                  </S.StatusToken>
                  <S.DetailRoute onClick={() => onDetailPageMoveHandler(item)}>
                    <span>상세보기</span>
                    <IconArrow width={20} height={20} />
                  </S.DetailRoute>
                </S.DetailRouteBox>
              </S.MainContentsItem>
            </S.MainContentsList>
          );
        })}
    </S.MyDrivePageContentLayout>
  );
};

export default MyDrivePageContent;
